<div>
    <h2 class="mt-3">{{'App.NotFound.Title'|translate}}</h2>
    <p>{{'App.NotFound.Content'|translate}}</p>
</div>
